import React from 'react'
import { Link } from 'gatsby'
import Obfuscate from 'react-obfuscate'
import PageTitle from '../../components/PageTitle'

import Layout from '../../components/Layout'

export default () => (
  <Layout>
    <PageTitle name="Policy on Information Requests" site="OIRA" />
    {/* <p className="holiday">
      During UA's holiday break (December 21 - January 1), OIRA will also be closed. Please allow for 10 business days after the holiday break for information requests to be fulfilled.
    </p> */}
    {/* <p className="holiday">
      During UA's Spring break (March 8 - March 16), OIRA will also be closed. Please allow for 10 business days after the break for information requests to be fulfilled.
    </p> */}
    <p>
      In effecting its mission, OIRA recognizes its service-orientation and
      strives to be as responsive as possible. In order to achieve the highest
      level of responsiveness, the Office looks for the most efficient and
      effective ways to perform its responsibilities.
    </p>

    <p>
      OIRA at The University of Alabama prepares various tabulations,
      spreadsheets, charts, and figures on the University's students, faculty,
      facilities, and finances. This information is published in an annual factbook,
      periodical FYI's, ad hoc reports, state and federal required reports, data
      exchange reports, and surveys for various national media. In most cases,
      the information is of a numerical nature; individual names are not given (i.e.,
      OIRA provides aggregate information, not individual data). Published information is
      readily available and shared.
    </p>

    <p>
      In order to be responsive to the constituencies of the University
      community, OIRA has implemented a web-based information request system.
      Please click on the link below to find the request form. Upon receipt of
      your request, OIRA will determine if the information requested is already
      available on our website or in some other published form. If the requested
      information is not readily available and will require additional time and
      effort to assimilate, for example writing a new computer program, the
      request will be evaluated and assigned. Although OIRA will strive to
      complete your request within ten working days, some information requests
      may require additional time. We thank you for your patience.
    </p>
    <p>
      <Link to="/requests/form">Click Here to Fill Out OIRA Request Form</Link>
    </p>
    <p>
      Mel Jenkins-Simpson
      <br />
      Associate Vice President, Institutional Research
      <br />
      The University of Alabama
      <br />
      Phone: <Obfuscate tel="205-348-7200" />
      <br />
      Fax: <Obfuscate tel="205-348-7208" />
      <br />
      Email:{' '}
      <Obfuscate
        email="msjenkinssimpson@ua.edu"
        headers={{ subject: 'Question from oira.ua.edu' }}
      />
    </p>
  </Layout>
)
